/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';
import type { AssetTypeResponseDto } from './AssetTypeResponseDto';
import {
    AssetTypeResponseDtoFromJSON,
    AssetTypeResponseDtoFromJSONTyped,
    AssetTypeResponseDtoToJSON,
    AssetTypeResponseDtoToJSONTyped,
} from './AssetTypeResponseDto';

/**
 * 
 * @export
 * @interface ListAssetTypesResponseDto
 */
export interface ListAssetTypesResponseDto {
    /**
     * 
     * @type {Array<AssetTypeResponseDto>}
     * @memberof ListAssetTypesResponseDto
     */
    data: Array<AssetTypeResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListAssetTypesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListAssetTypesResponseDto interface.
 */
export function instanceOfListAssetTypesResponseDto(value: object): value is ListAssetTypesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssetTypesResponseDtoFromJSON(json: any): ListAssetTypesResponseDto {
    return ListAssetTypesResponseDtoFromJSONTyped(json, false);
}

export function ListAssetTypesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetTypesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetTypeResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssetTypesResponseDtoToJSON(json: any): ListAssetTypesResponseDto {
    return ListAssetTypesResponseDtoToJSONTyped(json, false);
}

export function ListAssetTypesResponseDtoToJSONTyped(value?: ListAssetTypesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetTypeResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

